import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import useFunctions from "../ts/useFunctions";
import { Fragment } from "react/jsx-runtime";
import {
  ArrowBackIosNewRounded,
  Box,
  CustomIconButton,
} from "components/common";

interface ImageItem {
  original: string;
  thumbnail: string;
}

export default function ProductDetailMiddle() {
  const { loading, data, onBackClick } = useFunctions();
  const items = data.images.map((image) => ({
    original: image,
    thumbnail: image,
    // originalHeight: 500,
  }));
  return loading ? null : (
    <Fragment>
      <Box display={{ xs: "block", md: "none" }} marginBottom={2}>
        <CustomIconButton color="primary" onClick={onBackClick}>
          <ArrowBackIosNewRounded />
        </CustomIconButton>
      </Box>
      <ImageGallery
        lazyLoad
        items={items}
        infinite={false}
        thumbnailPosition="left"
        showPlayButton={false}
        showThumbnails={true}
        showFullscreenButton={false}
        showBullets={false}
        showNav={false}
      />
    </Fragment>
  );
}
